import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery, Grid, Button, Typography } from '@material-ui/core';
import { Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';
import {Box} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  image: {
    boxShadow:
      '25px 60px 125px -25px rgba(80,102,144,.1), 16px 40px 75px -40px rgba(0,0,0,.2)',
    borderRadius: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      maxWidth: 500,
    },
  },
}));

const Alloseqdna= props => {
  const { className, ...rest } = props;
  const classes = useStyles();

  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box  className={className} {...rest} marginBottom={2} marginLeft= {2} marginRight={2} marginTop= {2} display="flex" justifyContent="space-evenly" alignItems="center" padding={5} border="1px solid #ccc" borderRadius="4px">
      <Grid
        container
        justify="space-between"
        spacing={4}
        direction={isMd ? 'row' : 'column-reverse'}
      >
        <Grid
          item
          container
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <SectionHeader
            title={
              <span>
             HERO HEADLINE
                <br />
                <Typography component="span" variant="inherit" color="secondary">
                AlloSeq HCT
                </Typography>
              </span>
            }
            subtitle="AlloSeq HCT is an NGS-based solution enabling precise measurement 
            of engraftment following hematopoietic stem cell transplant
             for research applications
             
            "

            align="left"
            disableGutter
            titleVariant="h3"
          />


          <ul>
            <li>
            Simple, streamlined assay (one multiplexed reaction per sample)
            </li>
            <li>
            Targets 202 bi-allelic SNPs across 22 autosomes
            </li>

            <li>
            	Streamlined workflow with minimal hands-on time (2 hrs)

            </li>
            <li>
            	Sample to result in less than 24 hours with automatic analysis
            </li>
            <li>
            Highly sensitive (0.3% limit of detection)
            </li>

            <li>
            Accurate, precise, and reproducible results
            </li>
            <li>
            	User-friendly AlloSeq HCT software features automatic determination of informative loci, chimerism calculation, and results tracking

            </li>
            <li>
            Able to determine up to 3 genomes in a single sample; useful for double cord 
            </li>



          </ul>

          <SectionHeader
            
            ctaGroup={[
              <Button variant="contained" color="secondary" size="large">
               Quickbook
              </Button>,
              <Button variant="outlined" color="secondary" size="large">
               Talk to us
              </Button>,
            ]}
            align="left"
            disableGutter
            titleVariant="h3"
          />
        </Grid>
        <Grid
          item
          container
          justify="flex-start"
          alignItems="center"
          xs={12}
          md={6}
          data-aos={'fade-up'}
        >
          <Image
            src="https://ik.imagekit.io/j6phbjneuop/caredx/allohct_Ns-c_cymBZ7.png"
            alt="hct"
            className={classes.image}
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="2000"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

Alloseqdna.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default Alloseqdna;
